import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { NOTIFICATION_ID } from "../../constants/Notification";
import { PopupNames } from "../../constants/popup";
import UserType from "../../constants/UserType";
import { sendNotificationRequest } from "../../firebase/notification";
import { updateBenifitofVerificationPopup } from "../../firebase/popup";
import { getCookies, setCookies } from "../../helper/cookies";
import getProfileCompletenessValue from "../../helper/getProfileCompletenessValue";
import { RootState } from "../../redux/store";
import Button from "../Button";
import PopupComponent from "../PopupComponent";
import ProfileCompletenessChart from "../profile/ProfileCompletenessChart";

export type PopupCookie = {
  display: boolean;
};

const BenifitOfGettingVerifiedPopup = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const [open, setOpen] = useState<boolean>(false);
  const handleClose = () => {
    setOpen(false);
  };
  const profileCompleteness = getProfileCompletenessValue(user);

  /* 
  useEffect(() => {
    if (user.uid && open) {
      sendNotificationRequest(
        user.uid,
        user.userType === UserType.Client
          ? NOTIFICATION_ID.PU2L
          : NOTIFICATION_ID.PU2H
      );
    }
  }, [open, user.uid, user.userType]);
  */

  useEffect(() => {
    if (user.uid && profileCompleteness.value < 100) {
      if (!user.benifitOfVerificationPopup) {
        setOpen(true);

        setCookies<PopupCookie>(
          PopupNames.benifitOfCompletion,
          { display: false },
          1
        );
        updateBenifitofVerificationPopup(user.uid);
      } else {
        const shouldDisplay = getCookies<PopupCookie>(
          PopupNames.benifitOfCompletion,
          { display: true }
        );

        if (shouldDisplay?.display === true) {
          setOpen(true);
          setCookies<PopupCookie>(
            PopupNames.benifitOfCompletion,
            { display: false },
            1
          );
        }
      }
    }
  }, [user, profileCompleteness.value]);

  const newBody = (
    <>
      <ProfileCompletenessChart afterOnClick={handleClose} />
    </>
  );

  return (
    <PopupComponent
      body={newBody}
      button2Function={handleClose}
      notificationId={
        user.userType === UserType.Client
          ? NOTIFICATION_ID.PU2L
          : NOTIFICATION_ID.PU2H
      }
      user={user}
      open={open}
      handleClose={handleClose}
    />
  );
};

export default BenifitOfGettingVerifiedPopup;
